import _ from "lodash";
import {
  data_create_api_resource,
  data_fetch_api_resource,
} from '../../../utils/http_functions';

export const fetchAddress = () => async (dispatch, getState) => {
  const { token } = getState().auth;
  await dispatch({
      type: 'FETCH_ADDRESSES_REQUEST',
  })

  const result = await data_fetch_api_resource(token, 'addresses/');

  return dispatch({
    type: 'FETCH_ADDRESSES',
    payload: result && result.data
  });
};

export const setAddressError = (error_code) => {
  return ({
    type: 'SET_ADDRESS_ERROR',
    payload: error_code
  })
};

export const setAddress = value => async (dispatch, getState) => {
  dispatch({type: 'SET_ADDRESS_REQUEST'});
  const { token } = getState().auth;
  const { view_contract } = getState().contracts;
  try {
    let address_id = null;
    const result = await data_create_api_resource(token, `contracts/${view_contract.name}/notification/`, value);
    if (value.address_type === 'new') {
      await dispatch(fetchAddress());
      address_id = result.data.result;
    } else {
      address_id = value.address_id;
    }
    const { availableAddresses } = getState().contracts;
    const address = availableAddresses.filter(addr => addr.id === address_id)[0];
    dispatch({
        type: 'SET_ADDRESS',
        payload: address
    });
    dispatch({type: 'SET_ADDRESS_DONE'});
    dispatch(editContract(false));
  } catch (e) {
    if (e?.response?.status === 400 && e?.response?.data?.message == 'error_usuario_otra_vivienda_habitual_activa') {
      dispatch(setAddressError('error_ov_otra_vivienda_habitual'))
    } else {
      dispatch(setAddressError('no_error_defined'))
    }
  }
};

export const setIban = bank_account => async (dispatch) => {
  dispatch({
    type: 'SET_IBAN',
    payload: bank_account
  });
  dispatch(editContract(false));
};

export const setElectronicNotification = (status) => ({
  type: 'SET_ELECTRONIC_COMUNICATION',
  payload: status
});

export const setATRAvailable = (status) => ({
  type: 'SET_ATR_AVAILABLE',
  payload: status
});

export const setInvoiceOnline = (status) => ({
  type: 'SET_INVOICE_ONLINE',
  payload: status
});